import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import SidebarDrawer from "../SidebarDrawer/SidebarDrawer";

const mobileNavButtonClass = "js-siteheader-menubtn";

/**
 * The purpose of this class is the wrapping of the document queries for linking into the header defined in ASPX
 */

const MobileNavMulticompare: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = (): void => {
        setIsOpen(true);
    };

    useEffect(() => {
        // There should only be a single item
        const menuButton = document.getElementsByClassName(mobileNavButtonClass).item(0);

        if (menuButton) {
            menuButton.addEventListener("click", handleOpen);
        }

        return (): void => {
            menuButton && menuButton.removeEventListener("click", handleOpen);
        };
    });

    return (
        <SidebarDrawer
            isOpen={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}>
            <Sidebar onClose={() => setIsOpen(false)} />
        </SidebarDrawer>
    );
};

export default React.memo(MobileNavMulticompare);
